import { Navigate, useLocation } from "react-router";

export function AIDashboards() {
  const location = useLocation();
  return <Navigate to={`/home/dashboards${location.search}${location.hash}`} replace />;
}
